import { newNotification } from 'actions';
import { getCurrentLocale } from 'selectors';
import { getI18nInstance } from 'utils/translations';
import * as ACTION_TYPES from '../../../constants';

const listenedActions = [
  ACTION_TYPES.CANCEL_PAYMENT_SUCCESS,
  ACTION_TYPES.UPDATE_SMS_NOTIFICATION_SUCCESS,
  ACTION_TYPES.DELETE_FILE_SUCCESS,
  ACTION_TYPES.UPDATE_USER_SUCCESS,
  ACTION_TYPES.CHANGE_USER_PASSWORD_SUCCESS,
  ACTION_TYPES.UPDATE_PAYMENT_SUCCESS,
  ACTION_TYPES.UPLOAD_REFUND_KYC_DOCUMENT_FAILURE,
  ACTION_TYPES.REMOVE_CREDIT_CARD_SUCCESS,
  ACTION_TYPES.REMOVE_CREDIT_CARD_FAILURE,
  ACTION_TYPES.SAVE_CARD_SUCCESS,
  ACTION_TYPES.UPLOAD_LRS_SUCCESS,
  ACTION_TYPES.CANCEL_RECURRING_RECEIVABLE_FAILURE,
  ACTION_TYPES.INTERNAL_SERVER_FAILURE,
  ACTION_TYPES.SAVED_SUCCESSFULLY,
];

const checkoutListenedActions = [
  ACTION_TYPES.UPLOAD_DOCUMENT_SUCCESS,
  ACTION_TYPES.UPLOAD_DOCUMENT_FAILURE,
  ACTION_TYPES.UPLOAD_DOCUMENT_MAX_FILES_FAILURE,
];

const isError = (type: string) => type.includes('FAILURE');

const UINotifications = (store: any) => (next: any) => (action: any) => {
  const { type, payload } = action;

  if (listenedActions.includes(type)) {
    dispatchNotification(store, 'notifications', type, payload);
  }

  if (checkoutListenedActions.includes(type)) {
    dispatchNotification(store, 'checkout.notifications', type, payload);
  }

  return next(action);
};

const dispatchNotification = (
  store: any,
  prefix: string,
  type: string,
  payload: any,
) => {
  const state = store.getState();
  const locale = getCurrentLocale(state);
  const i18n = getI18nInstance(locale);
  const messageKey = `${prefix}.${type.toLowerCase()}`;
  const message = i18n.t(messageKey, payload);
  let notificationType = 'success';

  if (isError(type)) {
    notificationType = 'error';
  }

  store.dispatch(newNotification({ message, type: notificationType }));
};

export { UINotifications };
